import axios from 'axios';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import SkuReportProductPage from './skuReportProductPage';
import { setAntecedentInfo } from '../../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatConfidence, formatDateToShortString, formatDateToTodayTime, formatLift, formatSupport } from '../../../../common/common';
import PerformanceTrendChart from './PerformanceTrendChart';
import CustomerSegmentChart from './CustomerSegmentChart';
import CustomerPopupWithOrder from '../customerPopupwithOrder';
import JourneyPanel from './JourneyPanel';
import ConsequentProductData from './consequentProductData';
import ProductDesign from './productDesign';
import WebhookProductTable from './WebhookProductTable';


let settigsPage = [
  // { id: 'collection-page', label: 'Collection Page', value: 1 },cart-drawer-page
  { id: 'product-page', label: 'Product Page', value: 2 },
  { id: 'cart-page', label: ' Cart Page', value: 3 },
  { id: 'cart-drawer-page', label: ' Cart Drawer Page', value: 4 },
  // { id: 'before-checkout-page', label: ' Before Checkout Page', value: 4 },
  { id: 'checkout-page', label: 'Checkout Page', value: 5 },
  { id: 'post-purchase-page', label: 'Post-Purchase Page', value: 6 },
]

function phaseToText(phase) {
  const phases = {
    'browsing': 'Browsing',
    'product': 'Product Page',
    'cart': 'Cart',
    'checkout': 'Checkout',
    'postpurchase': 'Post-Purchase'
  };
  return phases[phase];
}

function getPhaseColor(phase) {
  const colors = {
    'browsing': 'blue',
    'product': 'purple',
    'cart': 'green',
    'checkout': 'yellow',
    'postpurchase': 'red'
  };
  return colors[phase];
}

const SkuListPage = ({
  order_details_id
}) => {
  const currentAnalysisData = useSelector((state) => state.analysisData.currentAnalysisData);
  const selectedSkuReport = useSelector((state) => state.analysisData.selectedSkuReport);

  const [loading, setLoading] = useState(true);
  const [mainSkuListResponse, setMainSkuListResponse] = useState({});
  const [skuListResponse, setSkuListResponse] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  // const [showSkuReportProductPage, setShowSkuReportProductPage] = useState(false);
  const [analysisResult, setAnalysisResult] = useState([]);
  const [top5Sku, setTop5Sku] = useState([]);
  const [activeTabs, setActiveTabs] = useState(1)
  const [showPopup, setShowPopup] = useState(false);
  const [antecedentProductData, setAntecedentProductData] = useState({});
  const [antecedentSku, setAntecedentSku] = useState("");
  const [consequentProductData, setConsequnetProductData] = useState({});
  const [forJsonDataToPush, setForJsonDataToPush] = useState([]);
  const [pushedSku, setPushedSku] = useState([]);
  const [pushedSetting, setPushedSetting] = useState([]);
  const [search, setSearch] = useState("");
  const [activeRow, setActiveRow] = useState("")
  const [jurneyPanel, setJurneyPanel] = useState(1)
  const [journeyModal, setJourneyModal] = useState(false)
  const [jurneyPhase, setJurneyPhase] = useState("")
  const [totalUniqueProduct, setTotalUniqueProduct] = useState(0);
  const [totalPushedSku, setTotalPushedSku] = useState(0);
  const [top30Sku, setTop30Sku] = useState([]);
  const [orderDetailsInfo, setOrderDetailsInfo] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [productList, setProductList] = useState([]);
  const [sku, setSku] = useState([]);
  const [listPushedDataResponse, setListPushedDataResponse] = useState([]);
  const [listPushedToShopifyDataResponse, setListPushedToShopifyDataResponse] = useState([]);

  const [isPushedOn, setIsPushedOn] = useState(false);
  const [isEditPushed, setIsEditPushed] = useState(false);
  const [isEditId, setIsEditId] = useState("");
  const [collectionPageData, setCollectionPageData] = useState([]);
  const [productPageData, setProductPageData] = useState([]);
  const [cartPageData, setCartPageData] = useState([]);
  const [beforeCheckoutPageData, setBeforeCheckoutPageData] = useState([]);
  const [CheckoutPageData, setCheckoutPageData] = useState([]);
  const [postPurchasePageData, setPostPurchasePageData] = useState([]);
  const [isAnalysisDataLoad, setIsAnalysisDataLoad] = useState(false)
  const [filterOption, setFilterOption] = useState("higher");
  const [mainSkuLogs, setMainSkuLogs] = useState([]);
  const [webhookProductData, setWebhookProductData] = useState([]);
  const [topCombinations, setTopCombinations] = useState(null);


  const [selectedTabs, setSelectedTabs] = useState("collection");
  const [applyToPage, setApplyToPage] = useState("");
  const [applyToPageForRemove, setApplyToPageForRemove] = useState("");

  const [selectedSkuData, setSelectedSkuData] = useState([]);
  const [collectionPageSku, setCollectionPageSku] = useState([]);
  const [productPageSku, setProductPageSku] = useState([]);
  const [cartPageSku, setCartPageSku] = useState([]);
  const [beforeCheckoutPageSku, setBeforeCheckoutPageSku] = useState([]);
  const [CheckoutPageSku, setCheckoutPageSku] = useState([]);
  const [postPurchasePageSku, setPostPurchasePageSku] = useState([]);
  const [skuApiDetails, setSkuApiDetails] = useState({
    isApply: false,
    isRemove: false,
    isRemoveAll: false
  })
  const [pendingPushedData,setPendingPushedData] = useState([]);
  const [successPushedData,setSuccessPushedData] = useState([]);
  const [jurneyTabs,setJurneyTabs] = useState(1)
  const [loadPushedSku,setLoadPushedSku] = useState({});
  const [loadRemovedSku,setLoadRemovedSku] = useState({});
  const [loadPushedToAll,setLoadPushedToAll] = useState(false)
  const [loadBulkPushedToShopify,setLoadBulkedPushedToShopify] = useState(false)
  const [loadBulkRemovedToShopify,setLoadBulkedRemovedToShopify] = useState(false)
  const [startDate,setStartDate] = useState("");
  const [endDate,setEndDate] = useState("");



   useEffect(() => {
    // Get today's date
    const today = new Date();
    // Format date as YYYY-MM-DD
    const formatDate = (date) => {
      return date.toISOString().split("T")[0];
    };
    // Set end date to today
    const end = formatDate(today);
    // Set start date to 1 month before today
    const start = new Date(today);
    start.setMonth(start.getMonth() - 1);

    setStartDate(formatDate(start));
    setEndDate(end);
  }, []);


  useEffect(()=>{
    if(startDate == ""){
      fetchwebhookData()
    }
  },[startDate])



  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchOrderDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}/order/order-details-by-id?order_details_id=${order_details_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      setOrderDetailsInfo(response.data.data);
    } catch (err) {
      if (err.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error("Failed to fetch SKU reports");
    } finally {
      setLoading(false);
    }
  };

  const fetchwebhookData = async () => {
    try {
      let queryParams = '';
      if (startDate || endDate || order_details_id) {
        const params = new URLSearchParams();
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (order_details_id) params.append("order_details_id",order_details_id)
        
        queryParams = `?${params.toString()}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}/order/webhook-list-products${queryParams}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      setWebhookProductData(response.data.data.reverse());
    } catch (err) {
      if (err.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error("Failed to fetch SKU reports");
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
    // fetchwebhookData();
  }, []);

  const handleView = (asku, csku, allsku, isSignle) => {
    setModalOpen(true);
    setSku({
      antecedentSKU: asku,
      consequentSKU: csku,
      allSku: allsku,
    });
  };


  // useEffect(()=>{
  //   console.log(pendingPushedData,"listPushedDataResponse");
  // },[pendingPushedData])

  const handlePushedSetting = (isChecked, value) => {
    if (value === 0) {
      if (isChecked) {
        setPushedSetting([0, 1, 2, 3, 4, 5, 6]);
      } else {
        setPushedSetting([]);
      }
    } else {
      setPushedSetting((prevData) => {
        const updated = new Set(prevData);

        if (isChecked) {
          updated.add(value);

          // If all 1–5 are selected, also include 0
          const childValues = [1, 2, 3, 4, 5, 6];
          const allChildrenSelected = childValues.every(v => updated.has(v));

          if (allChildrenSelected) updated.add(0);

        } else {
          updated.delete(value);
          // If any child is deselected, also remove 0 (parent)
          updated.delete(0);
        }

        return Array.from(updated);
      });
    }
  };


  const getPushedSkuListData = async () => {
    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}/ecommerce/list-pushed-data?analysis_details_id=${currentAnalysisData._id}&order_details_id=${order_details_id}&sku_reports_id=${selectedSkuReport._id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      let collectionPage = [];
      let productPage = [];
      let cartPage = [];
      let beforeCheckout = [];
      let checkout = [];
      let postPurchase = [];

      let pushed = [];
      let pending = [];

      response.data.data.map((data) => {
        if (Array.isArray(data?.pushedSettings)) {
          if (data.pushedSettings.includes(1)) {
            collectionPage.push(data);
          }
          if (data.pushedSettings.includes(2)) {
            productPage.push(data);
          }
          if (data.pushedSettings.includes(3)) {
            cartPage.push(data);
          }
          if (data.pushedSettings.includes(4)) {
            beforeCheckout.push(data);
          }
          if (data.pushedSettings.includes(5)) {
            checkout.push(data);
          }
          if (data.pushedSettings.includes(6)) {
            postPurchase.push(data);
          }
      }


        if (data.status === "pushed") {
          if(data.pushedSku.length > 0 && data.pushedSettings !== ""){
            // console.log(data.pushedSku.length,"uuuuuuuuuuuuuuuuuu")
            pushed.push(data);

          }
        } else {
          if(data.pushedSku.length > 0 && data.pushedSettings !== ""){
            // console.log(data.pushedSku.length,"uuuuuuuuuuuuuuuuuu")
            pending.push(data);

          }
          
        }

      })

      setCartPageData(cartPage);
      setCollectionPageData(collectionPage);
      setProductPageData(productPage);
      setBeforeCheckoutPageData(beforeCheckout);
      setCheckoutPageData(checkout);
      setPostPurchasePageData(postPurchase);
      setListPushedDataResponse(response.data.data)

      setPendingPushedData(pending);
      setSuccessPushedData(pushed);


    } catch (error) {
      if (error.response?.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error(error.response?.data?.message || error.message);
    }
  }


  const getPushedToShopiFyDataSkuListData = async () => {
    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}/ecommerce/list-pushed-to-shopify-data?analysis_details_id=${currentAnalysisData._id}&order_details_id=${order_details_id}&sku_reports_id=${selectedSkuReport._id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      // let collectionPage = [];
      // let productPage = [];
      // let cartPage = [];
      // let beforeCheckout = [];
      // let checkout = [];
      // let postPurchase = [];

      // response.data.data.map((data) => {
      //   if (data.pushedSettings.includes(1)) {
      //     collectionPage.push(data)
      //   }
      //   if (data.pushedSettings.includes(2)) {
      //     productPage.push(data)
      //   }
      //   if (data.pushedSettings.includes(3)) {
      //     cartPage.push(data)
      //   }
      //   if (data.pushedSettings.includes(4)) {
      //     beforeCheckout.push(data)
      //   }
      //   if (data.pushedSettings.includes(5)) {
      //     checkout.push(data)
      //   }
      //   if (data.pushedSettings.includes(6)) {
      //     postPurchase.push(data)
      //   }
      // })

      // setCartPageData(cartPage);
      // setCollectionPageData(collectionPage);
      // setProductPageData(productPage);
      // setBeforeCheckoutPageData(beforeCheckout);
      // setCheckoutPageData(checkout);
      // setPostPurchasePageData(postPurchase);
      setListPushedToShopifyDataResponse(response.data.data.reverse())
    } catch (error) {
      console.log(error,"errorerrorerrorerror")
      if (error.response?.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error(error.response?.data?.message || error.message);
    }
  }


  const handlePushedToShopify = async (isEditPushed, id) => {
    try {
      if (pushedSku.length === 0) {
        toast.error("Select product that you want to show.")
        return;
      }
      if (pushedSetting.length === 0) {
        toast.error("Select which page you show.")
        return;
      }

      const dataForDb = {
        order_details_id: order_details_id,
        analysis_details_id: currentAnalysisData._id,
        sku_reports_id: selectedSkuReport._id,
        mainProductDetails: antecedentProductData,
        pushedSkuDetails: forJsonDataToPush,
        mainSku: antecedentSku,
        pushedSku: pushedSku,
        status: "pending",
        pushedSettings: pushedSetting
      }
      setIsPushedOn(true)

      let url = isEditPushed ? `${process.env.REACT_APP_API_END_POINT}/ecommerce/update-pushed-data?pushed_shopify_id=${id}` : `${process.env.REACT_APP_API_END_POINT}/ecommerce/create-pushed-data`;

      if (isEditPushed) {
        const response = await axios.put(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

      } else {
        const response = await axios.post(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }


      setShowPopup(false)
      setActiveRow("")
      getPushedSkuListData();
      getPushedToShopiFyDataSkuListData();
      toast.success("Pushed Succefully!")
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error("Pushed error!")
    } finally {
      setIsPushedOn(false)
    }
  }


  useEffect(() => {
    if (forJsonDataToPush.length > 0 && pushedSku.length > 0) {

      // console.log(forJsonDataToPush,"forJsonDataToPush")

      if (skuApiDetails.isApply) {
        handlePushedToShopifyNew()
      }
      if (skuApiDetails.isRemove) {
        handleRemovedToSavedSku()
      }
      if (skuApiDetails.isRemoveAll) {
        handleRemovedToFromAllSavedSku()
      }
    }
  }, [forJsonDataToPush, skuApiDetails]);



  const handleRemovedToSavedSku = async (isEditPushed = false, id) => {
    try {
      let pushedSkus = []
      forJsonDataToPush.map((item)=>{
        pushedSkus.push(item.sku);
      })
      const dataForDb = {
        order_details_id: order_details_id,
        analysis_details_id: currentAnalysisData._id,
        sku_reports_id: selectedSkuReport._id,
        mainProductDetails: antecedentProductData,
        pushedSkuDetails: forJsonDataToPush,
        mainSku: antecedentSku,
        pushedSku: pushedSkus,
        status: "pending",
        type: "removed",
        pushedSettings: applyToPageForRemove
      }
      let url = isEditPushed ? `${process.env.REACT_APP_API_END_POINT}/ecommerce/update-pushed-data?pushed_shopify_id=${id}` : `${process.env.REACT_APP_API_END_POINT}/ecommerce/removed-pushed-data`;

      if (isEditPushed) {
        const response = await axios.put(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

      } else {
        const response = await axios.post(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }

      setSelectedSkuData([]);
      setPushedSku([]);
      setForJsonDataToPush([]);
      setApplyToPage("")
      setApplyToPageForRemove("")
      toast.success("Removed from the list.")
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error("Pushed error!")
    } finally {
      // setIsPushedOn(false)
    }
  }



  const handleRemovedToFromAllSavedSku = async (isEditPushed = false, id) => {
    try {
      const dataForDb = {
        order_details_id: order_details_id,
        analysis_details_id: currentAnalysisData._id,
        sku_reports_id: selectedSkuReport._id,
        mainProductDetails: antecedentProductData,
        pushedSkuDetails: forJsonDataToPush,
        mainSku: antecedentSku,
        pushedSku: pushedSku,
        status: "pending",
        type: "removed",
        pushedSettings: applyToPageForRemove
      }
      let url = isEditPushed ? `${process.env.REACT_APP_API_END_POINT}/ecommerce/update-pushed-data?pushed_shopify_id=${id}` : `${process.env.REACT_APP_API_END_POINT}/ecommerce/removed-from-all-pages-pushed-data`;

      if (isEditPushed) {
        const response = await axios.put(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

      } else {
        const response = await axios.post(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }

      setSelectedSkuData([]);
      setPushedSku([]);
      setForJsonDataToPush([]);
      setApplyToPage("")
      setApplyToPageForRemove("")
      toast.success("Removed Succefully!")
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error("Pushed error!")
    } finally {
      // setIsPushedOn(false)
    }
  }



  const handlePushedToShopifyNew = async (isEditPushed = false, id) => {
    try {

      let pushedSkus = []
      forJsonDataToPush.map((item)=>{
        pushedSkus.push(item.sku);
      })

      console.log(productPageSku,"productPageSkuproductPageSku")

      const dataForDb = {
        order_details_id: order_details_id,
        analysis_details_id: currentAnalysisData._id,
        sku_reports_id: selectedSkuReport._id,
        mainProductDetails: antecedentProductData,
        pushedSkuDetails: forJsonDataToPush,
        mainSku: antecedentSku,
        pushedSku: pushedSkus,
        status: "pending",
        type: "saved",
        pushedSettings: applyToPage
      }
      // setIsPushedOn(true)

      let url = isEditPushed ? `${process.env.REACT_APP_API_END_POINT}/ecommerce/update-pushed-data?pushed_shopify_id=${id}` : `${process.env.REACT_APP_API_END_POINT}/ecommerce/create-pushed-data`;

      if (isEditPushed) {
        const response = await axios.put(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

      } else {
        const response = await axios.post(
          url,
          dataForDb,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }

      setSelectedSkuData([]);
      setPushedSku([]);
      setForJsonDataToPush([]);
      setApplyToPage("")
      setApplyToPageForRemove("")


      // setShowPopup(false)
      // setActiveRow("")
      getPushedSkuListData();
      // getPushedToShopiFyDataSkuListData();
      toast.success("Your changes have been saved.")
    } catch (error) {
      if (error?.response?.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      toast.error("Pushed error!")
    } finally {
      // setIsPushedOn(false)
    }
  }


  const getAnlysisResultByAnalysisDetailsId = async () => {
    try {
      setIsAnalysisDataLoad(true)
      const response = await fetch(
        `${process.env.REACT_APP_ORDER_ANALYSIS_RESULT}?analysis_details_id=${currentAnalysisData._id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const newResponse = await response.json();
      if (!response.ok) {
        if (newResponse?.detail?.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login");
        }
        throw new Error(
          newResponse.detail?.message || "Failed to fetch analysis history"
        );
      }

      setAnalysisResult(newResponse.data)

      toast.success("Analysis Result fetched successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {

    } finally {
      setLoading(false)
      setIsAnalysisDataLoad(false)
    }
  };

  useEffect(() => {
    getAnlysisResultByAnalysisDetailsId();
    getPushedSkuListData();
    getPushedToShopiFyDataSkuListData()
  }, [])



  const pushedToShopify = async (id,isPushAll,index) => {
    
    try {
        if(loadPushedSku[index]){
            return
        }
        let url;
        if(isPushAll){
            setLoadPushedToAll(true)
            url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/pushed-to-shopify?isPushAll=${true}`;
        }else{
           url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/pushed-to-shopify?pushed_shopify_id=${id}`;
        }
      
      setLoadPushedSku((old)=>{
        return {
          ...old,
          [index]: true
        }
      })
      const response = await axios.put(
        url,
        {}, // Put an empty object if there's no data to send
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      getPushedSkuListData()
  
      toast.success("Pushed Successfully!");
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      console.error("Push failed:", error);
      toast.error("Push failed.");
    }finally{
      setLoadPushedSku((old)=>{
        return {
          ...old,
          [index]: false
        }
      })
      setLoadPushedToAll(false)
    }
  };


  const bulkPushedToShopify = async ({
    mainSku
  }) => {
    try {
        // if(loadPushedSku[index]){
        //     return
        // }
        setLoadBulkedPushedToShopify(true)
        let url;
       
          url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/bulk-pushed-to-shopify?mainSku=${mainSku}`;
      
      // setLoadPushedSku((old)=>{
      //   return {
      //     ...old,
      //     [index]: true
      //   }
      // })
      const response = await axios.put(
        url,
        {}, // Put an empty object if there's no data to send
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // getPushedSkuListData()
  
      toast.success("Pushed Successfully!");
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      console.error("Push failed:", error);
      // toast.error("Push failed.");
      toast.error(`❌ No product found for SKU: ${mainSku}`);
    }finally{
      // setLoadPushedSku((old)=>{
      //   return {
      //     ...old,
      //     [index]: false
      //   }
      // })
      // setLoadPushedToAll(false)
      setLoadBulkedPushedToShopify(false)
    }
  };



  const bulkRemovedToShopify = async ({
    mainSku
  }) => {
    try {
      setLoadBulkedRemovedToShopify(true)
        let url;
        url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/bulk-removed-to-shopify?mainSku=${mainSku}`;
      
      const response = await axios.put(
        url,
        {}, // Put an empty object if there's no data to send
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      toast.success("Removed Successfully!");
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      console.error("Push failed:", error);
      toast.error(`❌ No product found for SKU: ${mainSku}`);
    }finally{
      setLoadBulkedRemovedToShopify(false)
    }
  };


  const removeFromShopify = async (id,isPushAll,index) => {
    
    try {
        if(loadRemovedSku[index]){
            return
        }
        let url;
        if(isPushAll){
            url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/pushed-to-shopify?isPushAll=${true}&page=${1}`;
        }else{
           url = `${process.env.REACT_APP_API_END_POINT}/ecommerce/removed-to-shopify?pushed_shopify_id=${id}`;
        }
      
      setLoadRemovedSku((old)=>{
        return {
          ...old,
          [index]: true
        }
      })
      const response = await axios.put(
        url,
        {}, // Put an empty object if there's no data to send
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      getPushedSkuListData()
  
      toast.success("Pushed Successfully!");
    } catch (error) {
      if (error.response.data?.detail?.isExpireToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        navigate("/login")
      }
      console.error("Push failed:", error);
      toast.error("Push failed.");
    }finally{
      setLoadRemovedSku((old)=>{
        return {
          ...old,
          [index]: false
        }
      })
    }
  };



  useEffect(() => {
    // console.log(analysisResult,"kkkkkkkkkkk",selectedSkuReport)
    let uniqueSkuMap = {};
    let top5skudata = [];
    let top30skudata = [];
    let uniqueProduct = {};

    let filteredData = [];

    analysisResult
      .sort((a, b) => b.confidence - a.confidence)
      .map((data) => {
        let totalPurchasedTogether = Math.round(
          data.support * currentAnalysisData?.totalOrder
        )
        let antecedentPurchasedTogether = Math.round(
          data.antecedent_support * currentAnalysisData?.totalOrder
        )
        let antecedentsData = data.antecedents;
        let consequentData = data.consequent;

        let totalData = [...data.antecedents, ...data.consequent];
        // count unique product
        totalData.map((data) => {
          if (data.sku && !uniqueProduct[data.sku]) {
            uniqueProduct[data.sku] = data;
          }
        })
        if (Number(selectedSkuReport?.min_customer) <= Number(data.together_customer_count) && Number(selectedSkuReport?.min_order) <= Number(totalPurchasedTogether) && antecedentsData.length === 1) {
          antecedentsData.map((item) => {
            let count = {};
            if (item.sku && !uniqueSkuMap[item.sku]) {

              // count combinations
              analysisResult
                .map((data2) => {
                  let totalPurchasedTogether2 = Math.round(
                    data.support * currentAnalysisData?.totalOrder
                  )
                  let antecedentsData2 = data2.antecedents;
                  let consequentData2 = data2.consequent;
                  if (Number(selectedSkuReport?.min_customer) <= Number(data2.together_customer_count) && Number(selectedSkuReport?.min_order) <= Number(totalPurchasedTogether2) && antecedentsData2.length === 1) {
                    antecedentsData2.map((item3) => {
                      if (item3.sku === item.sku) {
                        consequentData2.map((item4) => {
                          if (item4.sku && !count[item4.sku]) {
                            count[item4.sku] = "item4.sku";
                          }
                        })
                      }
                    })
                  }
                })

              let updateItem = {
                ...item,
                confidence: data.confidence,
                support: data.support,
                totalPurchasedTogether: totalPurchasedTogether,
                antecedentPurchasedTogether: antecedentPurchasedTogether,
                antecedent_customer_count: data.antecedent_customer_count,
                lift: data.lift,
                together_customer_count: data.together_customer_count,
                totalCombination: Object.entries(count).length
              }
              uniqueSkuMap[item.sku] = updateItem;
            }

          })
        }
      })
    // setTotalUniqueProduct(Object.entries(uniqueProduct).length)

    const topItems = analysisResult
      .filter((item) => {
        const totalPurchasedTogether = Math.round(
          item.support * currentAnalysisData?.totalOrder
        );

        return (
          item.antecedents.length === 1 &&
          item.consequent.length === 1 &&
          Number(selectedSkuReport?.min_customer) <= Number(item.together_customer_count) &&
          Number(selectedSkuReport?.min_order) <= Number(totalPurchasedTogether)
        );
      })
      .map((item) => ({
        ...item,
        totalPurchasedTogether: Math.round(item.support * currentAnalysisData?.totalOrder)
      }))
      .sort((a, b) => b.totalPurchasedTogether - a.totalPurchasedTogether)
      .slice(0, 10);

    // console.log(topItems);

    // console.log(topItems,"uniqueSkuMapTTTT")

    setTopCombinations(topItems)

    // setTop30Sku(top30skudata);
    const top5 = Object.entries(uniqueSkuMap)
      .sort((a, b) => b[1].totalCombination - a[1].totalCombination)
      .slice(0, 10)
      .map(([key, value]) => ({ sku: key, ...value }));

    setTop5Sku(top5)


    const sort = Object.entries(uniqueSkuMap)
      .sort((a, b) => b[1].totalCombination - a[1].totalCombination)
      .map(([key, value]) => ({ sku: key, ...value }));

    setSkuListResponse(sort)
    setMainSkuListResponse(sort);
  }, [analysisResult])

  useEffect(() => {
    const lowerQuery = search.trim().toLowerCase();
    const filtered = Object.entries(mainSkuListResponse)
      .filter(([_, item]) => {
        const title = item.product_title?.toLowerCase() || "";
        const sku = item.sku?.toLowerCase() || "";
        return sku.toLowerCase() === (lowerQuery) || title.includes(lowerQuery);
      })
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});


    let sort = {};
    if (filterOption === "higher") {
      sort = Object.entries(filtered)
        .sort((a, b) => b[1].totalCombination - a[1].totalCombination)
        .map(([key, value]) => ({ sku: key, ...value }));
    } else {
      sort = Object.entries(filtered)
        .sort((a, b) => a[1].totalCombination - b[1].totalCombination) // lower first
        .map(([key, value]) => ({ sku: key, ...value }));
    }

    setSkuListResponse(sort)
  }, [search, filterOption])





  useEffect(() => {
    let uniqueSkuMap = {};
    analysisResult
      .map((data) => {
        let totalPurchasedTogether = Math.round(
          data.support * currentAnalysisData?.totalOrder
        )
        let antecedentsData = data.antecedents;
        let consequentData = data.consequent;

        let antecedentSkus = [];
        let consequentSkus = [];

        antecedentsData.forEach((sku) => {
          antecedentSkus.push(sku.sku);
        });

        consequentData.forEach((sku) => {
          consequentSkus.push(sku.sku);
        });

        if (Number(selectedSkuReport?.min_customer) <= Number(data.together_customer_count) && Number(selectedSkuReport?.min_order) <= Number(totalPurchasedTogether) && antecedentsData.length === 1) {
          antecedentsData.map((item) => {
            if (item.sku === antecedentProductData.sku) {
              consequentData.map((consequntItem) => {

                let updateItem = {
                  ...consequntItem,
                  confidence: data.confidence,
                  support: data.support,
                  totalPurchasedTogether: totalPurchasedTogether,
                  lift: data.lift,
                  together_customer_count: data.together_customer_count,
                  antecedent_customer_count: data.antecedent_customer_count,
                  antecedentSkus,
                  consequentSkus,
                  allSkus: [...antecedentSkus, ...consequentSkus],
                  allData: data
                }
                if (consequntItem.sku && !uniqueSkuMap[consequntItem.sku]) {
                  uniqueSkuMap[consequntItem.sku] = updateItem;
                }
              })
            }
          })
        }
      })
    setConsequnetProductData(uniqueSkuMap)
  }, [antecedentProductData])


  let itemsPerPage = 10
  const allItems = Object.values(skuListResponse);
  const totalItems = allItems.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginateData = allItems.slice(startIndex, startIndex + itemsPerPage);
  const startPage = Math.max(1, currentPage - Math.floor(itemsPerPage / 2));
  const endPage = Math.min(totalPages, startPage + itemsPerPage - 1);
  const visiblePages = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };
  // console.log(paginateData,"paginateData")


  const handleCarousel = (move) => {
    const carouselContainer = document.querySelector('.carousel-container');
    const scrollAmount = 280; // Adjust based on card width + gap
    let scrollPosition = 0;
    if (move === "prev") {
      scrollPosition = Math.max(scrollPosition - scrollAmount, 0);
      carouselContainer.style.transform = `translateX(-${scrollPosition}px)`;
    } else {
      const maxScroll = carouselContainer.scrollWidth - carouselContainer.clientWidth;
      scrollPosition = Math.min(scrollPosition + scrollAmount, maxScroll);
      carouselContainer.style.transform = `translateX(-${scrollPosition}px)`;
    }
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (


    <main class="bg-white rounded-lg shadow overflow-hidden">
      <div class="">
        <div class="flex border-b border-gray-200 mb-6">
          <button id="overview-tab"
            class={`tab-button py-4 px-6 text-center  font-medium text-sm flex items-center justify-center border-blue-500   ${activeTabs === 1 ? 'border-b-2 border-blue-500 active text-blue-600' : 'hover:text-blue-600 hover:border-blue-500'}`}
            onClick={() => {
              setActiveTabs(1)
            }}
          >
            <i class="fas fa-chart-pie mr-2"></i>  Overview
          </button>
          <button id="sku-tab"
            class={`tab-button  px-4 py-2 text-sm font-medium text-center   ${activeTabs === 2 ? 'border-b-2 border-blue-500 active text-blue-600' : 'hover:text-blue-600 hover:border-blue-500'}`}
            onClick={() => {
              setActiveTabs(2)
            }}
          >
            <i class="fas fa-project-diagram mr-2"></i>  Product List
          </button>
          <button id="sku-tab"
            class={`hidden tab-button  px-4 py-2 text-sm font-medium text-center   ${activeTabs === 3 ? 'border-b-2 border-blue-500 active text-blue-600' : 'hover:text-blue-600 hover:border-blue-500'}`}
            onClick={() => {
              setActiveTabs(3)
              getPushedSkuListData()
            }}
          >
            <i class="fas fa-users mr-2"></i>  Customer Journey Upsell Points
          </button>
          <button id="sku-tab"
            class={`tab-button  px-4 py-2 text-sm font-medium text-center   ${activeTabs === 4 ? 'border-b-2 border-blue-500 active text-blue-600' : 'hover:text-blue-600 hover:border-blue-500'}`}
            onClick={() => {
              setActiveTabs(4)
            }}
          >
            <i class="fas fa-store mr-2"></i>  Orders With Upsell
          </button>
        </div>

      </div>
      <div className='p-6s'>
        {
          activeTabs === 1 &&
          <div id="overview-content" class="tab-content active">
            {
              !isAnalysisDataLoad &&
          <div>
              <div className='w-full px-6'>
                    <div class=" w-full">
                      <h2 class="text-2xl font-bold text-gray-800 flex items-center gap-2">
                        SKU Report – Understanding Your Frequently Bought Together Data
                      </h2>

                      <p class="text-gray-700 mb-3">
                        A report derived from <span class="font-semibold">Market Basket Analysis</span> for each SKU in your store.  
                        Based on your order data, we calculate which other SKUs — and how many times each of them — have accompanied the main SKU in customer orders.
                      </p>

                      <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
                        <h3 class="font-semibold text-gray-800 mb-1">Analysis Criteria</h3>
                        <p class="text-gray-600 text-sm">
                          The SKU report includes only SKUs that meet the minimum thresholds:  
                          <span class="font-semibold"> 5 orders</span> and <span class="font-semibold">5 unique customers</span>.  
                          For example, a SKU appears in the report only if it has been purchased in more than 5 orders and by at least 5 different customers.
                        </p>
                      </div>
                  </div>
                 </div>
              <div className='flex flex-col lg:flex-row gap-6'>
                <div className='w-full lg:w-2/3 px-6 py-6'>
                  <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2 mb-8'>
                    <div class="bg-indigo-50 rounded-lg p-6 border border-indigo-100">
                      <div class="flex items-center justify-between">
                        <div class="flex items-center">
                          <div class="p-3 rounded-full bg-indigo-100 text-indigo-600 mr-4">
                            <i class="fas fa-shopping-cart text-xl"></i>
                          </div>
                          <div>
                            <p class="text-sm font-medium text-gray-600">Total Orders Analyzed</p>
                            <p class="text-2xl font-bold text-gray-800">{currentAnalysisData?.totalOrder.toLocaleString('en-US')}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="bg-indigo-50 rounded-lg p-6 border border-indigo-100">
                      <div class="flex items-center justify-between">
                        <div class="flex items-center">
                          <div class="p-3 rounded-full bg-indigo-100 text-indigo-600 mr-4">
                            <i class="fas fa-shopping-cart text-xl"></i>
                          </div>
                          <div>
                            <p class="text-sm font-medium text-gray-600">Total Line Items Analyzed</p>
                            <p class="text-2xl font-bold text-gray-800">{currentAnalysisData?.totalProduct.toLocaleString('en-US')}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 '>
                    <div class="bg-white p-4 rounded-lg border border-gray-200 ">
                      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                          <p class="text-sm font-medium text-gray-600">Orders Date Range</p>
                          <p class="text-md text-gray-800">{formatDateToShortString(orderDetailsInfo.start_date)} - {formatDateToShortString(orderDetailsInfo.end_date)}</p>
                        </div>
                        <div>
                          <p class="text-sm font-medium text-gray-600">Orders Fetched Date</p>
                          <p class="text-md text-gray-800">{formatDateToShortString(orderDetailsInfo?.createdAt)}</p>
                        </div>
                        <div>
                          <p class="text-sm font-medium text-gray-600">Report Generated Date</p>
                          <p class="text-md text-gray-800">{formatDateToShortString(currentAnalysisData?.createdAt)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className='w-full lg:w-1/3'>
                  <div class="summary-card p-6 mb-6">
                    <h3 class="text-lg font-semibold text-gray-800 mb-4">Analysis Criteria</h3>
                    <div class="space-y-4">
                      <div class="flex items-start">
                        <div class="flex-shrink-0 bg-red-100 p-2 rounded-lg text-red-700 mt-1">
                          <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="ml-3">
                          <h4 class="text-sm font-medium text-gray-800">Minimum Orders</h4>
                          <p class="text-sm text-gray-600">{selectedSkuReport.min_order}</p>
                        </div>
                      </div>
                      <div class="flex items-start">
                        <div class="flex-shrink-0 bg-yellow-100 p-2 rounded-lg text-yellow-700 mt-1">
                          <i class="fas fa-tags"></i>
                        </div>
                        <div class="ml-3">
                          <h4 class="text-sm font-medium text-gray-800">Minimum Customers</h4>
                          <p class="text-sm text-gray-600">{selectedSkuReport.min_customer}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className='w-full lg:w-1/3'>
                  <div class="summary-card p-6 mb-6">
                    <h3 class="text-lg font-semibold text-gray-800 mb-4">Analysis Result</h3>
                    <div class="space-y-4">
                      <div class="flex items-start">
                        <div class="flex-shrink-0 bg-indigo-100 p-2 rounded-lg text-indigo-700 mt-1">
                          <i class="fas fa-chart-line"></i>
                        </div>
                        <div class="ml-3">
                          <h4 class="text-sm font-medium text-gray-800">Total Products Found</h4>
                          <p class="text-sm text-gray-600">{Object.entries(skuListResponse).length}</p>
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
              </div>
            }


            {isAnalysisDataLoad && (
              <div className="flex justify-center items-center h-32">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                <span className="ml-2 text-blue-600">Loading analysis...</span>
              </div>
            )}

            {
              !isAnalysisDataLoad &&
              <div class="grid gap-6 grid-cols-2 px-6">
                <div class="bg-white p-6 rounded-lg border border-gray-200">
                  <div class="flex items-center justify-between mb-4">
                    <h3 class="text-lg font-medium text-gray-900">Top Performing Pairs</h3>
                  </div>
                  <div class="custom-graph">
                    <PerformanceTrendChart top5sku={top5Sku} topCombinations={topCombinations} />
                  </div>
                </div>

                <div class="bg-white p-6 rounded-lg border border-gray-200">
                  <h3 class="text-lg font-semibold text-gray-800 mb-4">Frequently Purchased Together</h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
                          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
                          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Frequently Bought With</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        {
                          top5Sku.length > 2 && top5Sku.map((data) => {
                            return (
                              <tr>
                                <td className="px-4 py-3 text-sm font-medium text-blue-600 break-words max-w-xs">
                                  {data.product_title}
                                </td>
                                <td className="px-4 py-3 text-sm text-gray-500">{data?.sku}</td>
                                <td className="px-4 py-3 text-sm text-gray-500">{data.totalCombination} Products</td>
                              </tr>
                            );
                          })
                        }

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            }

            <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">



            </div>


          </div>
        }
        {
          activeTabs === 2 &&
          <div id="sku-content" class="tab-content px-6">
            <div className="flex items-center justify-end w-full mb-4">
              {/* Search input */}
              <div className="relative w-1/3 min-w-[200px]">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="fas fa-search text-gray-400"></i>
                </div>
                <input
                  type="text"
                  id="sku-search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
                  placeholder="Search Products / SKUs..."
                />
              </div>

              {/* <select
                value={filterOption}
                onChange={(e) => setFilterOption(e.target.value)}
                className="hidden border border-gray-200 text-gray-900 bg-white text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 mr-4 ml-4" 
              >
                <option value="higher">Higher Match Found</option>
                <option value="lower">Lower Match Found</option>
              </select> */}

              {/* Export button */}
              {/* <button className="ml-4 bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-2 rounded-lg flex items-center gap-2 transition-colors border border-gray-300">
                  <i className="fas fa-download"></i>Export
                </button> */}
            </div>




            <div class="bg-white rounded-lg border border-gray-100 overflow-hidden mb-8">
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr
                    >
                      <th scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        SKU</th>
                      <th scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Product Name</th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                          onClick={() => {
                            if (filterOption === "higher") {
                              setFilterOption("lower");
                            } else {
                              setFilterOption("higher");
                            }
                          }}
                        >
                          <div className="flex items-center justify-center gap-1">
                            Frequently Purchased With
                            <span className="flex flex-col">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 text-gray-400 hover:text-gray-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 text-gray-400 hover:text-gray-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            </span>
                          </div>
                        </th>
                      <th scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    {
                      paginateData.length > 0 && paginateData.map((data) => {

                        let findPushedData = listPushedDataResponse.find((item) => item.mainSku == data.sku)

                        let findPushedToShopify = listPushedToShopifyDataResponse.find((item) => item.mainSku == data.sku)
                        return <tr
                          class={`hover:bg-gray-50 cursor-pointer sku-row ${activeRow === data.sku && 'bg-blue-300'}`}
                          data-sku={data.sku}
                          onClick={() => {
                            setAntecedentProductData(data)
                            setAntecedentSku(data.sku)
                            setShowPopup(true)
                            setActiveRow(data.sku)
                            if (findPushedData) {
                              // console.log(findPushedData, "findPushedData")
                              setPushedSetting(findPushedData.pushedSettings)
                              // setPushedSku(findPushedData.pushedSku)
                              setIsEditPushed(true)
                              setIsEditId(findPushedData._id)
                              setForJsonDataToPush(findPushedData.pushedSkuDetails)

                            } else {
                              setForJsonDataToPush([])
                              setPushedSetting([]);
                              setPushedSku([]);
                              setIsEditPushed(false)
                              setIsEditId("")
                            }
                          }}
                        >
                          <td class="px-6 py-4 whitespace-nowrap">
                            <div class="flex items-center">
                              <div
                                class="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-lg flex items-center justify-center">
                                <img
                                  src={
                                    data.image ? data.image : "noimage.jpg"
                                  }
                                />
                              </div>
                              <div class="ml-4">
                                <div class="text-sm font-medium text-gray-900">{data.sku}</div>
                              </div>
                            </div>
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap align-center">
                            <div className="text-sm font-medium text-gray-900 mb-1">
                              <div>{data.product_title}</div>
                            </div>

                            <div class="flex flex-col gap-1 text-xs text-gray-700 mt-1">
                            </div>
                          </td>
                          <td class="px-6 py-4 text-center whitespace-nowrap">
                            <span class="px-2 py-1 bg-indigo-100 text-indigo-800 text-xs rounded-full">{data.totalCombination} Products</span>
                          </td>
                          {/* <td class="px-6 py-4 whitespace-nowrap text-center">
                            {
                              findPushedData ? (
                                <>
                                  <span class="text-xs font-medium">
                                    <span class="text-green-600">{findPushedToShopify?.pushedSku?.length || 0} pushed</span>, &nbsp;
                                    <span class="text-blue-600">{findPushedData.pushedSku.length} saved</span>, &nbsp;
                                    <span class="text-yellow-600">{(data.totalCombination - findPushedData?.pushedSku?.length)}  remaining</span>
                                  </span>
                                </>
                              ) : (
                                <span className="text-xs text-gray-500 font-medium">
                                  Not Action yet
                                </span>
                              )
                            }



                          </td> */}
                          <td class="px-6 py-4  text-xs text-green-600 hover:text-green-800 ">
                            <span className="cursor-pointer text-blue-700"> <i class="fas fa-store mr-1"></i> {findPushedData?.pushedSku?.length === data.totalCombination ? 'Build Upsell' : 'Build Upsell'}</span>
                          </td>
                        </tr>
                      })
                    }
                  </tbody>
                </table>
              </div>
              {
                totalItems > 1 &&
                <div className="bg-gray-50 px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                  <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                    <div>
                      <p className="text-sm text-gray-700">
                        Showing{" "}
                        <span className="font-medium">{startIndex + 1}</span> to{" "}
                        <span className="font-medium">
                          {Math.min(startIndex + itemsPerPage, totalItems)}
                        </span>{" "}
                        of <span className="font-medium">{totalItems}</span> results
                      </p>
                    </div>
                    <div>
                      <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                          className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50"
                        >
                          <i className="fas fa-chevron-left h-5 w-5" />
                        </button>

                        {visiblePages.map((page) => (
                          <button
                            key={page}
                            onClick={() => handlePageChange(page)}
                            className={`${currentPage === page
                              ? "z-10 bg-blue-50 border-blue-500 text-blue-600"
                              : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50"
                              } relative inline-flex items-center px-4 py-2 border text-sm font-medium`}
                          >
                            {page}
                          </button>
                        ))}

                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50"
                        >
                          <i className="fas fa-chevron-right h-5 w-5" />
                        </button>
                      </nav>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        {
          activeTabs === 4 &&





          <div className="w-full bg-white rounded-2xl overflow-hidden h-full px-6">
  <div className="border border-gray-200 overflow-hidden mb-6">
    <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
      <h3 className="text-lg font-semibold text-gray-800 flex items-center space-x-2">
        <i className="fas fa-filter text-blue-500"></i>
        <span>Advanced Filters</span>
      </h3>
      <button className="text-sm text-blue-600 hover:text-blue-800 flex items-center space-x-1"
      onClick={()=>{
        setEndDate("");
        setStartDate("")
      }}
      >
        <i className="fas fa-redo"></i>
        <span>Reset All</span>
      </button>
    </div>

    <div className="p-6">
      <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
        Date Range
      </label>
      <div className="grid grid-cols-6 gap-3 items-end">
        <div className="relative">
          <input
            type="date"
            className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md bg-gray-50"
            value={startDate}
            onChange={(e)=>{
              setStartDate(e.target.value)
            }}
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <i className="far fa-calendar text-gray-400"></i>
          </div>
        </div>
        <div className="relative">
          <input
            type="date"
            className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md bg-gray-50"
            value={endDate}
            onChange={(e)=>{
              setEndDate(e.target.value)
            }}
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <i className="far fa-calendar text-gray-400"></i>
          </div>
        </div>
        <button
          className="w-1/3  bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-blue-700 transition-all"
          onClick={fetchwebhookData}
        >
          Submit
        </button>
      </div>
    </div>
  </div>

  <WebhookProductTable data={webhookProductData} />
</div>

        }

        {
          activeTabs === 3 &&
          <>
            <div class=" mb-6">



              <div class="mb-6 border-b border-gray-200">
                <ul class="flex flex-wrap -mb-px" id="tabs">
                  <li class="mr-2">
                    <button class={`inline-block py-4 px-4 text-sm font-medium text-center border-b-2  rounded-t-lg hover:text-blue-600 hover:border-blue-600 tab-button ${jurneyTabs === 1 && 'border-blue-600 text-blue-600'}`} data-tab="pending" aria-current="page"
                      onClick={()=>{
                        setJurneyTabs(1)
                      }}
                    >
                      <i class="fas fa-clock mr-2"></i>Pending Push
                      <span class="ml-2 bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">{pendingPushedData.length}</span>
                    </button>
                  </li>
                  <li class="mr-2">
                    <button class={`inline-block py-4 px-4 text-sm font-medium text-center border-b-2  rounded-t-lg hover:text-blue-600 hover:border-blue-600 tab-button ${jurneyTabs === 2 && 'border-blue-600 text-blue-600'}`} data-tab="pushed"
                    onClick={()=>{
                      setJurneyTabs(2)
                    }}
                    >
                      <i class="fas fa-check-circle mr-2"></i>Pushed to Shopify
                      <span class="ml-2 bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">{successPushedData.length}</span>
                    </button>
                  </li>

                </ul>
              </div>

              <div id="pushed-tab" class="tab-content active">
                {
                  jurneyTabs === 1 &&
                  <div class=" mb-6">
                  <div class="py-4 border-b border-gray-200 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <h2 class="text-xl font-semibold text-gray-800 flex items-center gap-2">
                    <i class="fas fa-clock mr-2 text-yellow-500"></i> Pending to Push to shopify

                    </h2>
                    <div class="flex items-center gap-3">
                      {/* <div class="relative w-full md:w-64">
                        <input type="text" placeholder="Search pushed items..." class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                        <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                      </div>
                      <button class="bg-blue-50 hover:bg-blue-100 text-blue-600 px-3 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
                        <i class="fas fa-filter"></i> Filters
                      </button> */}

                      {
                        pendingPushedData.length > 0 && 
                        <button class="bg-blue-50 hover:bg-blue-100 text-blue-600 px-3 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
                      onClick={()=>{
                        pushedToShopify("",true)
                        }}
                        disabled={loadPushedToAll}
                      >
                        {
                          loadPushedToAll ? "Please wait..." : "Push All To Shopify"
                        }
                      </button>
                      }
                      
                    </div>
                  </div>
                  <div class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Main Sku</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Along With Sku</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Updated</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        {
                          pendingPushedData.length > 0 && pendingPushedData.map((data,index)=>{
                            return <tr class="hover:bg-gray-50">
                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{data.mainSku}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{data.mainProductDetails.product_title}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{settigsPage.find((item)=> item.value == data.pushedSettings)?.label}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{data.pushedSku.join(",")}</td>
                            <td class="px-6 py-4 whitespace-nowrap">
                              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">{data.status}</span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDateToTodayTime(data.updatedAt)}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 flex gap-2">
                            <button
                              onClick={() => pushedToShopify(data._id,"",index)}
                              className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium hover:bg-blue-200"
                            >
                              {
                                  loadPushedSku[index] ? "Please wait.." : "Push to Shopify"
                              }
                            </button>
                            {/* <button
                              className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-medium hover:bg-red-200"
                            >
                              Remove
                            </button> */}
                          </td>
                          </tr>
                          })
                        }
                        {
                          pendingPushedData.length === 0 &&
                          <tr>
                            <td
                              colSpan={7}
                              className="px-6 py-4 text-center text-sm text-gray-500"
                            >
                              No Upsell Orders Found
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  {/* <div class="px-6 py-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
                    <div class="text-sm text-gray-600">
                      Showing <span class="font-medium">1</span> to <span class="font-medium">5</span> of <span class="font-medium">1,234</span> results
                    </div>
                    <div class="flex items-center gap-2">
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 disabled:opacity-50" disabled>
                        Previous
                      </button>
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-gray-100 text-gray-700 font-medium">
                        1
                      </button>
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50">
                        2
                      </button>
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50">
                        Next
                      </button>
                    </div>
                  </div> */}
                </div>
                }

                {
                  jurneyTabs === 2 &&
                  <div class=" mb-6">
                  <div class=" py-4 border-b border-gray-200 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <h2 class="text-xl font-semibold text-gray-800 flex items-center gap-2">
                      <i class="fas fa-check-circle text-green-500"></i> Successfully Pushed Items
                    </h2>
                    {/* <div class="flex items-center gap-3">
                      <div class="relative w-full md:w-64">
                        <input type="text" placeholder="Search pushed items..." class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                        <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                      </div>
                      <button class="bg-blue-50 hover:bg-blue-100 text-blue-600 px-3 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
                        <i class="fas fa-filter"></i> Filters
                      </button>
                    </div> */}
                  </div>
                  <div class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Main Sku</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Along With Sku</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Updated</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        {
                          successPushedData.length > 0 && successPushedData.map((data,index)=>{
                            return <tr class="hover:bg-gray-50">
                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{data.mainSku}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{data.mainProductDetails.product_title}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{settigsPage.find((item)=> item.value == data.pushedSettings).label}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{data.pushedSku.join(",")}</td>
                            <td class="px-6 py-4 whitespace-nowrap">
                              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">{data.status}</span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDateToTodayTime(data.updatedAt)}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 flex gap-2">
                            <button
                              className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-medium hover:bg-red-200"
                              onClick={()=>{
                                removeFromShopify(data._id,"",index)
                              }}
                            >
                              
                              {
                                  loadRemovedSku[index] ? "Please wait.." : "Remove"
                              }
                            </button>
                          </td>
                          </tr>
                          })
                        }
                        {
                          successPushedData.length === 0 &&
                          <tr>
                            <td
                              colSpan={7}
                              className="px-6 py-4 text-center text-sm text-gray-500"
                            >
                              No data found
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
                }
              </div>

              <div id="pending-tab" class="tab-content hidden">
                <div class="bg-white shadow rounded-lg overflow-hidden mb-6">
                  <div class="px-6 py-4 border-b border-gray-200 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <h2 class="text-xl font-semibold text-gray-800 flex items-center gap-2">
                      <i class="fas fa-clock text-yellow-500"></i> Items Pending Push to Shopify
                    </h2>
                    <div class="flex items-center gap-3">
                      <div class="relative w-full md:w-64">
                        <input type="text" placeholder="Search pending items..." class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
                        <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                      </div>
                      <button class="bg-yellow-50 hover:bg-yellow-100 text-yellow-600 px-3 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
                        <i class="fas fa-exclamation-triangle mr-1"></i> Push All
                      </button>
                    </div>
                  </div>
                  <div class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product ID</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr class="hover:bg-gray-50">
                          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">#2001</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Limited Edition Sneakers</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">New York</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">PRD-SN-2001</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">15</td>
                          <td class="px-6 py-4 whitespace-nowrap">
                            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 flex items-center gap-1">
                              <span class="h-2 w-2 rounded-full bg-yellow-500 animate-pulse"></span> Pending
                            </span>
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <button class="text-blue-600 hover:text-blue-800">Push Now</button>
                          </td>
                        </tr>
                        <tr class="hover:bg-gray-50">
                          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">#2002</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Organic Cotton Tote Bag</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Los Angeles</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">PRD-TB-2002</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">30</td>
                          <td class="px-6 py-4 whitespace-nowrap">
                            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 flex items-center gap-1">
                              <span class="h-2 w-2 rounded-full bg-yellow-500 animate-pulse"></span> Pending
                            </span>
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <button class="text-blue-600 hover:text-blue-800">Push Now</button>
                          </td>
                        </tr>
                        <tr class="hover:bg-gray-50">
                          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">#2003</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Smartphone Holder</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Chicago</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">PRD-SH-2003</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">22</td>
                          <td class="px-6 py-4 whitespace-nowrap">
                            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 flex items-center gap-1">
                              <span class="h-2 w-2 rounded-full bg-yellow-500 animate-pulse"></span> Pending
                            </span>
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <button class="text-blue-600 hover:text-blue-800">Push Now</button>
                          </td>
                        </tr>
                        <tr class="hover:bg-gray-50">
                          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">#2004</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Bluetooth Speaker</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">New York</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">PRD-BS-2004</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">18</td>
                          <td class="px-6 py-4 whitespace-nowrap">
                            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 flex items-center gap-1">
                              <span class="h-2 w-2 rounded-full bg-yellow-500 animate-pulse"></span> Pending
                            </span>
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <button class="text-blue-600 hover:text-blue-800">Push Now</button>
                          </td>
                        </tr>
                        <tr class="hover:bg-gray-50">
                          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">#2005</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Yoga Mat</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Los Angeles</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">PRD-YM-2005</td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">25</td>
                          <td class="px-6 py-4 whitespace-nowrap">
                            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 flex items-center gap-1">
                              <span class="h-2 w-2 rounded-full bg-yellow-500 animate-pulse"></span> Pending
                            </span>
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <button class="text-blue-600 hover:text-blue-800">Push Now</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="px-6 py-4 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
                    <div class="text-sm text-gray-600">
                      Showing <span class="font-medium">1</span> to <span class="font-medium">5</span> of <span class="font-medium">56</span> results
                    </div>
                    <div class="flex items-center gap-2">
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 disabled:opacity-50" disabled>
                        Previous
                      </button>
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-gray-100 text-gray-700 font-medium">
                        1
                      </button>
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50">
                        2
                      </button>
                      <button class="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50">
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
























              <div class="flex items-center mb-2">
              </div>

              <div class="relative mb-8 hidden">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                  <div class="w-full border-t border-gray-200"></div>
                </div>
                <div class="relative flex justify-between" id="journeyTabs">
                  <button data-phase="browsing" class={`journey-tab bg-white px-4 py-2 text-sm font-medium  border  rounded-full  ${jurneyPanel === 1 ? 'active-tab hover:bg-blue-50 border-blue-600 text-blue-600' : 'text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                    onClick={() => {
                      setJurneyPanel(1)
                    }}
                  >
                    <i class="fas fa-search mr-1"></i> Collection Page
                  </button>
                  <button data-phase="product" class={`journey-tab bg-white px-4 py-2 text-sm font-medium  border  rounded-full  ${jurneyPanel === 2 ? 'active-tab hover:bg-blue-50 border-blue-600 text-blue-600' : 'text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                    onClick={() => {
                      setJurneyPanel(2)
                    }}
                  >
                    <i class="fas fa-tag mr-1"></i> Product Page
                  </button>
                  <button data-phase="cart" class={`journey-tab bg-white px-4 py-2 text-sm font-medium  border  rounded-full  ${jurneyPanel === 3 ? 'active-tab hover:bg-blue-50 border-blue-600 text-blue-600' : 'text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                    onClick={() => {
                      setJurneyPanel(3)
                    }}
                  >
                    <i class="fas fa-shopping-cart mr-1"></i> Cart
                  </button>
                  <button data-phase="checkout" class={`journey-tab bg-white px-4 py-2 text-sm font-medium  border  rounded-full  ${jurneyPanel === 6 ? 'active-tab hover:bg-blue-50 border-blue-600 text-blue-600' : 'text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                    onClick={() => {
                      setJurneyPanel(6)
                    }}
                  >
                    <i class="fas fa-credit-card mr-1"></i> Before Checkout
                  </button>
                  <button data-phase="checkout" class={`journey-tab bg-white px-4 py-2 text-sm font-medium  border  rounded-full  ${jurneyPanel === 4 ? 'active-tab hover:bg-blue-50 border-blue-600 text-blue-600' : 'text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                    onClick={() => {
                      setJurneyPanel(4)
                    }}
                  >
                    <i class="fas fa-credit-card mr-1"></i> Checkout
                  </button>
                  <button data-phase="postpurchase" class={`journey-tab bg-white px-4 py-2 text-sm font-medium  border  rounded-full  ${jurneyPanel === 5 ? 'active-tab hover:bg-blue-50 border-blue-600 text-blue-600' : 'text-gray-700 border-gray-300 hover:bg-gray-50'}`}
                    onClick={() => {
                      setJurneyPanel(5)
                    }}
                  >
                    <i class="fas fa-box-open mr-1"></i> Post-Purchase
                  </button>
                </div>
              </div>










              <div id="journeyContent hidden" className='hidden'>
                <div class={`journey-panel ${jurneyPanel === 1 ? 'active-panel' : 'hidden'}`} data-phase="browsing">
                  <div class="flex items-start">
                    <JourneyPanel data={collectionPageData} getPushedSkuListData={getPushedSkuListData} page={1} />
                  </div>
                </div>

                <div class={`journey-panel ${jurneyPanel === 2 ? 'active-panel' : 'hidden'}`} data-phase="product">
                  <div class="flex items-start">
                    <JourneyPanel data={productPageData} getPushedSkuListData={getPushedSkuListData} page={2} />
                  </div>
                </div>

                <div class={`journey-panel ${jurneyPanel === 3 ? 'active-panel' : 'hidden'}`} data-phase="cart">
                  <div class="flex items-start">
                    <JourneyPanel data={cartPageData} getPushedSkuListData={getPushedSkuListData} page={3} />
                  </div>
                </div>

                <div class={`journey-panel ${jurneyPanel === 6 ? 'active-panel' : 'hidden'}`} data-phase="checkout">
                  <div class="flex items-start">
                    <JourneyPanel data={beforeCheckoutPageData} getPushedSkuListData={getPushedSkuListData} page={4} />
                  </div>
                </div>

                <div class={`journey-panel ${jurneyPanel === 4 ? 'active-panel' : 'hidden'}`} data-phase="checkout">
                  <div class="flex items-start">
                    <JourneyPanel data={CheckoutPageData} getPushedSkuListData={getPushedSkuListData} page={5} />
                  </div>
                </div>

                <div class={`journey-panel ${jurneyPanel === 5 ? 'active-panel' : 'hidden'}`} data-phase="postpurchase">
                  <div class="flex items-start">
                    <JourneyPanel data={postPurchasePageData} getPushedSkuListData={getPushedSkuListData} page={6} />
                  </div>
                </div>
              </div>
            </div>
          </>

        }


        {
          showPopup &&
          <div id="sku-detail-panel"
            class="max-w-7.5xl px-4 py-4 sm:px-6 lg:px-8 slide-over mt-10 fixed inset-y-0 right-0 w-full sm:w-1/2 lg:w-full bg-white shadow-xl z-20 overflow-y-auto slide-over-closed">
            <div class="p-6">
              <div class="flex items-center justify-between mb-6">
                <h3 class="text-xl font-bold text-gray-900">Product Details</h3>
                <button
                  className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-300 transition duration-300"
                  onClick={() => setShowPopup(false)}
                >
                  ← Back
                </button>
                {/* <button id="close-panel" class="p-2 rounded-full hover:bg-gray-100"
                  onClick={() => {
                    setShowPopup(false)
                  }}
                >
                  <i class="fas fa-times text-gray-400"></i>
                </button> */}
              </div>

              <div className="border border-gray-200 rounded-lg p-4">
                {/* <h2 className="text-xl  px-4 py-4 sm:px-6 lg:px-8font-semibold text-gray-800 mb-4">Main Product Information</h2> */}

                {/* Product Info Row */}
                <div className="flex items-start justify-between">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-16 w-16 rounded-lg overflow-hidden">
                      <img
                        src={antecedentProductData.image || "noimage.jpg"}
                        alt="Product"
                        className="w-16 h-16 object-contain rounded-md"
                      />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">
                        {antecedentProductData.product_title}
                      </h3>
                      <p className="text-sm font-mono text-gray-500">
                        {antecedentProductData.sku}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Quick Stats */}
                <div className="mt-6">
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <p className="text-sm text-gray-500">Total Orders</p>
                      <p className="text-lg font-semibold">
                        {antecedentProductData.antecedentPurchasedTogether}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Unique Customers</p>
                      <p className="text-lg font-semibold">
                        {antecedentProductData.antecedent_customer_count}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Frequently Purchased With</p>
                      <p className="text-lg font-semibold">
                        {antecedentProductData.totalCombination} Products
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-2  pt-6">
                {/* <h3 class="text-lg font-medium text-gray-900 mb-4">Frequently Purchased With</h3> */}
                {/* <ConsequentProductData
                  consequentProductData={consequentProductData}
                  setForJsonDataToPush={setForJsonDataToPush}
                  setPushedSku={setPushedSku}
                  setPushedSetting={setPushedSetting}
                  handleView={handleView}
                  setProductList={setProductList}
                  pushedSku={pushedSku}
                  paginateData={paginateData}
                  listPushedDataResponse={listPushedDataResponse}
                  setAntecedentProductData={setAntecedentProductData}
                  setAntecedentSku={setAntecedentSku}
                  setShowPopup={setShowPopup}
                  setActiveRow={setActiveRow}
                  setIsEditPushed={setIsEditPushed}
                  setIsEditId={setIsEditId}
                  setSearch={setSearch}
                  skuListResponse={mainSkuListResponse}
                  currentAnalysisData={currentAnalysisData}
                  order_details_id={order_details_id}
                  selectedSkuReport={selectedSkuReport}
                  antecedentProductData={antecedentProductData}
                  setMainSkuLogs={setMainSkuLogs}
                /> */}
                <ProductDesign
                  consequentProductData={consequentProductData}
                  pushedSku={pushedSku}
                  setPushedSku={setPushedSku}
                  selectedTabs={selectedTabs}
                  setSelectedTabs={setSelectedTabs}
                  applyToPage={applyToPage}
                  applyToPageForRemove={applyToPageForRemove}
                  setApplyToPage={setApplyToPage}
                  setApplyToPageForRemove={setApplyToPageForRemove}
                  selectedSkuData={selectedSkuData}
                  setSelectedSkuData={setSelectedSkuData}
                  collectionPageSku={collectionPageSku}
                  setCollectionPageSku={setCollectionPageSku}
                  productPageSku={productPageSku}
                  setProductPageSku={setProductPageSku}
                  cartPageSku={cartPageSku}
                  setCartPageSku={setCartPageSku}
                  beforeCheckoutPageSku={beforeCheckoutPageSku}
                  setBeforeCheckoutPageSku={setBeforeCheckoutPageSku}
                  CheckoutPageSku={CheckoutPageSku}
                  setCheckoutPageSku={setCheckoutPageSku}
                  postPurchasePageSku={postPurchasePageSku}
                  setPostPurchasePageSku={setPostPurchasePageSku}
                  setForJsonDataToPush={setForJsonDataToPush}
                  forJsonDataToPush={forJsonDataToPush}
                  handlePushedToShopifyNew={handlePushedToShopifyNew}
                  setSkuApiDetails={setSkuApiDetails}
                  skuApiDetails={skuApiDetails}
                  currentAnalysisData={currentAnalysisData}
                  selectedSkuReport={selectedSkuReport}
                  order_details_id={order_details_id}
                  antecedentProductData={antecedentProductData}
                  handleView={handleView}
                  setProductList={setProductList}
                  pushedToShopify={pushedToShopify}
                  bulkPushedToShopify={bulkPushedToShopify}
                  bulkRemovedToShopify={bulkRemovedToShopify}
                  loadBulkPushedToShopify={loadBulkPushedToShopify}
                  loadBulkRemovedToShopify={loadBulkRemovedToShopify}
                />
              </div>
              <div class=" bottom-0 bg-white pt-4 pb-6 ">
                {/* <div className="mt-6 border-t border-gray-200 pt-6 mb-5">
                  <p className="text-sm text-gray-500 mb-4">Great choice! Where should we surface these items?</p>
                  <div className="flex space-x-10">
                    <div className="space-y-3 flex-1">
                      {[
                        { id: 'all', label: '✅ All', value: 0 },
                        { id: 'collection-page', label: '🛒 Collection Page', value: 1 },
                        { id: 'product-page', label: '🏷️ Product Page', value: 2 },
                        { id: 'cart-page', label: '🛒 Cart Page', value: 3 },
                      ].map(({ id, label, value }) => (
                        <div className="flex items-center" key={id}>
                          <input
                            id={id}
                            type="checkbox"
                            className="h-4 w-4 text-blue-600 rounded"
                            checked={pushedSetting.some(item => item === value)}
                            onChange={(e) => handlePushedSetting(e.target.checked, value)}
                          />
                          <label htmlFor={id} className="ml-3 block text-sm font-medium text-gray-700">
                            {label}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="space-y-3 flex-1">
                      {[
                        { id: 'before-checkout-page', label: '💳 Before Checkout Page', value: 4 },
                        { id: 'checkout-page', label: '💳 Checkout Page', value: 5 },
                        { id: 'post-purchase-page', label: '🤝 Post-Purchase Page', value: 6 },
                      ].map(({ id, label, value }) => (
                        <div className="flex items-center" key={id}>
                          <input
                            id={id}
                            type="checkbox"
                            className="h-4 w-4 text-blue-600 rounded"
                            checked={pushedSetting.some(item => item === value)}
                            onChange={(e) => handlePushedSetting(e.target.checked, value)}
                          />
                          <label htmlFor={id} className="ml-3 block text-sm font-medium text-gray-700">
                            {label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>


                </div> */}

                {/* <div className="border-t border-gray-200 px-4 py-4 sm:px-6">
                  <button
                    className="w-full flex justify-center items-center px-4 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700"
                    onClick={() => {
                      handlePushedToShopify(isEditPushed, isEditId)
                    }}
                    disabled={isPushedOn}
                  >
                    <i class="fas fa-store mr-1"></i> {isPushedOn ? "Please wait..." : `${isEditPushed ? 'Update' : 'Save'} & Push Later`}
                  </button>
                  <div className="mt-2 text-xs text-gray-600 text-center">
                    <span className="">Last Saved On</span>{' '}
                    <i>{mainSkuLogs.length > 0 ? formatDateToTodayTime(mainSkuLogs[0]?.createdAt) : 'Not yet pushed'}</i>
                  </div>

                  <div className="mt-4">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">Pushed Logs</h4>


                       <ul className="relative">
                      {mainSkuLogs && mainSkuLogs.length > 0 ? (
                        mainSkuLogs.map((log, index) => (
                          <li key={index} className="relative timeline-item">
                            <div className="flex items-start pb-6 pt-2">

                              <div class={`${log.type=='saved'?'bg-gray-300':'bg-green-500'} rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0 relative z-10`}>
                                    <i class={`${log.type=='saved'?'fas fa-save text-white text-sm':'fas fa-store text-white text-sm'} `}></i>
                                </div>

                                <div class="ml-4 flex-grow">
                                    <div class="flex items-center justify-between">
                                        <h3 class="text-sm font-medium text-gray-900">{(log.type=='saved'?'Saved Sku':'Pushed to shopify')} </h3>
                                        <span class="text-xs text-gray-500">{formatDateToTodayTime(log.createdAt)}</span>
                                    </div>
                                    {log.pushedSku && log.pushedSku.length > 0 && (
                                      <p class="text-sm text-gray-600 mt-1">All items are being saved: {log.pushedSku.join(", ")}.</p>
                                        )}
                                      {log.pushedSettings && log.pushedSettings.length > 0 && (
                                          <p class="text-xs text-gray-600 mt-1">
                                              {log.pushedSettings
                                                .map(val => settigsPage.find(pg => pg.value === val)?.label)
                                                .filter(Boolean) // remove undefined
                                                .join(", ")}
                                            </p>
                                        )}
                                  
                                    <div class="mt-2">
                                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                            <i class="fas fa-clock mr-1"></i> {(log.type=='saved'?'saved':'Pushed')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="text-gray-500 text-xs">No logs available</li>
                      )}
                    </ul>
                  </div>


                </div> */}
              </div>
            </div>
          </div>
        }


        <div id="journeyModal" class={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${journeyModal ? '' : 'hidden'}`}>
          <div class="bg-white rounded-xl p-8 max-w-4xl w-full shadow-2xl">
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-2xl font-semibold">Full Customer Journey Analysis</h3>
              <button id="closeJourneyModal" class="text-gray-500 hover:text-gray-700"
                onClick={() => {
                  setJourneyModal(false)
                }}
              >
                <i class="fas fa-times"></i>
              </button>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
              <button data-phase="browsing" class={`journey-nav bg-blue-100 text-blue-700 p-3 rounded-lg font-medium flex flex-col items-center ${jurneyPhase === "browsing" && 'ring-2 ring-offset-2'}`}
                onClick={() => {
                  setJurneyPhase("browsing")
                }}
              >
                <i class="fas fa-search text-xl mb-2"></i>
                Browsing
              </button>
              <button data-phase="product" class={`journey-nav bg-purple-100 text-purple-700 p-3 rounded-lg font-medium flex flex-col items-center ${jurneyPhase === "product" && 'ring-2 ring-offset-2'}`}
                onClick={() => {
                  setJurneyPhase("product")
                }}
              >
                <i class="fas fa-tag text-xl mb-2"></i>
                Product Page
              </button>
              <button data-phase="cart" class={`journey-nav bg-green-100 text-green-700 p-3 rounded-lg font-medium flex flex-col items-center ${jurneyPhase === "cart" && 'ring-2 ring-offset-2'}`}
                onClick={() => {
                  setJurneyPhase("cart")
                }}
              >
                <i class="fas fa-shopping-cart text-xl mb-2"></i>
                Cart
              </button>
              <button data-phase="checkout" class={`journey-nav bg-yellow-100 text-yellow-700 p-3 rounded-lg font-medium flex flex-col items-center ${jurneyPhase === "checkout" && 'ring-2 ring-offset-2'}`}
                onClick={() => {
                  setJurneyPhase("checkout")
                }}
              >
                <i class="fas fa-credit-card text-xl mb-2"></i>
                Checkout
              </button>
              <button data-phase="postpurchase" class={`journey-nav bg-red-100 text-red-700 p-3 rounded-lg font-medium flex flex-col items-center ${jurneyPhase === "postpurchase" && 'ring-2 ring-offset-2'}`}
                onClick={() => {
                  setJurneyPhase("postpurchase")
                }}
              >
                <i class="fas fa-box-open text-xl mb-2"></i>
                Post-Purchase
              </button>
            </div>

            <div id="journeyModalContent">
              {
                jurneyPhase === "" &&
                <>
                  <div class="bg-blue-50 p-6 rounded-xl mb-6">
                    <h4 class="font-semibold text-lg mb-2 text-blue-800">Browsing Phase Insights</h4>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div>
                        <div class="bg-white p-4 rounded-lg shadow">
                          <h5 class="font-medium mb-1">Top Performers</h5>
                          <ul class="text-sm space-y-1 mt-2">
                            <li class="flex items-start">
                              <span class="text-blue-500 mr-2">•</span>
                              "Frequently Bought Together" (75% acceptance)
                            </li>
                            <li class="flex items-start">
                              <span class="text-blue-500 mr-2">•</span>
                              "Complete Your Setup" (68% lift)
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <div class="bg-white p-4 rounded-lg shadow">
                          <h5 class="font-medium mb-1">Conversion Rates</h5>
                          <div class="mt-2">
                            <div class="flex justify-between text-xs mb-1">
                              <span>Standard</span>
                              <span>1.8%</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-2">
                              <div class="bg-gray-600 h-2 rounded-full" style={{ width: "25%" }}></div>
                            </div>
                            <div class="flex justify-between text-xs mt-3 mb-1">
                              <span>With Upsells</span>
                              <span>4.7%</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-2">
                              <div class="bg-blue-500 h-2 rounded-full" style={{ width: "65%" }}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="bg-white p-4 rounded-lg shadow">
                          <h5 class="font-medium mb-1">Best Practices</h5>
                          <ul class="text-sm space-y-1 mt-2">
                            <li class="flex items-start">
                              <span class="text-blue-500 mr-2">•</span>
                              Show cross-category suggestions
                            </li>
                            <li class="flex items-start">
                              <span class="text-blue-500 mr-2">•</span>
                              Limit to 3-5 recommendations
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="bg-gradient-to-r from-blue-600 to-purple-600 p-6 rounded-xl text-white">
                    <h4 class="font-semibold text-lg mb-2">Next Steps</h4>
                    <ul class="space-y-2">
                      <li class="flex items-start">
                        <span class="text-yellow-300 mr-2">•</span>
                        <span>Implement "Frequently Bought Together" on all category pages - <span class="italic">projected +22% revenue</span></span>
                      </li>
                      <li class="flex items-start">
                        <span class="text-yellow-300 mr-2">•</span>
                        <span>Test "Complete Your Setup" bundles for top 5 categories</span>
                      </li>
                      <li class="flex items-start">
                        <span class="text-yellow-300 mr-2">•</span>
                        <span>Create seasonal bundles for holiday shopping</span>
                      </li>
                    </ul>
                  </div>
                </>
              }
              {jurneyPhase !== "" &&
                <div class={`bg-${getPhaseColor(jurneyPhase)}-50 p-6 rounded-xl mb-6`}>
                  <h4 class={`font-semibold text-lg mb-2 text-${getPhaseColor(jurneyPhase)}-800`}>{phaseToText(jurneyPhase)} Phase Insights</h4>
                  <p>Detailed analytics and recommendations for the {phaseToText(jurneyPhase)} phase would appear here.</p>
                </div>
              }
            </div>
          </div>
        </div>

        {isModalOpen && order_details_id && (
          <CustomerPopupWithOrder
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            title="Popup Title"
            order_details_id={order_details_id}
            sku={sku}
            isBoth={{
              antecedent: false,
              consequent: false,
              all: true,
            }}
            isSingleExclude={currentAnalysisData.isExclude}
            productList={productList}
          />
        )}

      </div>
    </main>
  );
};

export default SkuListPage;
